<template>
  <div class="cx">
    <Header title="重修报名" type="0" route="/homeIndex"></Header>

    <div class="content">
      <div class="select">
        <div class="sem-drop">
          <div @click="semPicker = true">
            <p>{{ this.semester }}</p>
            <i></i>
          </div>
        </div>
        <van-popup v-model="semPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="semesterList"
            :default-index="defaultIndex"
            @cancel="semPicker = false"
            @confirm="semConfirm"
            :item-height="itemHeight"
          />
        </van-popup>
      </div>
      <NOdata
        v-if="this.cxList && this.cxList.length == 0"
        title="未查询到重修数据"
      ></NOdata>
      <div v-else class="list-box">
        <div class="list-item" v-for="(item, index) in cxList" :key="index">
          <div class="item-top">
            <p>{{ item.kcmc }}</p>
            <van-row>
              <van-col span="14">
                <ul>
                  <li>
                    是否报名：{{
                      item.sfbm ? (item.sfbm == 0 ? "×" : "√") : "-"
                    }}
                  </li>
                  <li>总学时：{{ item.zxs }}</li>
                  <li>学分：{{ item.xf }}</li>
                  <li>课程编号：{{ item.kch }}</li>
                  <li>最好成绩：{{ item.zhcj }}</li>
                  <li>考试性质：{{ item.ksxzmc }}</li>
                </ul>
              </van-col>
              <van-col span="8">
                <ul>
                  <li>课程性质：{{ item.kcxzkcxz }}</li>
                  <li>成绩标识：{{ item.cjbsmc }}</li>
                  <li>上课校区：{{ item.xiaoqumc }}</li>
                  <li>上课班级：{{ item.skbj }}</li>
                  <li>上课教师：{{ item.skjs }}</li>
                  <li>教师院系：{{ item.skjsyx }}</li>
                </ul>
              </van-col>
            </van-row>
          </div>
          <span
            v-if="item.sfbm == '0' && sfkbm == true && czCtroller == '1'"
            class="bmClass"
            @click="bm(item)"
          >
            立即报名
          </span>
          <!-- <span
          class="qxbmClass"
          v-if="
            item.sfbm == '1' &&
              sfkbm == true &&
              item.sfjf == '0' &&
              item.skys == '0' &&
              item.kkys == '0' &&
              item.sfxk == '0'
          "
          @click="cancelBm(item)"
        >
          取消报名
        </span> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      semPicker: false,
      semesterList: [
        {
          text: "全部",
          value: ""
        }
      ],
      semester: "学年学期",
      semesterId: "",
      defaultIndex: 0,
      itemHeight: 35,
      cxList: [{}],
      sfkbm: "",
      czCtroller: ""
    };
  },
  methods: {
    async semList() {
      let concatList = [];
      Api.getSemesterList()
        .then(res => {
          res.data.forEach((item, index) => {
            concatList[index] = {
              text: item.semesterName,
              value: item.semesterId
            };
            if (item.isdqxq == "1") {
              this.semester = item.semesterName;
              this.semesterId = item.semesterId;
              this.defaultIndex = index + 1;
            }
          });
          this.semesterList = this.semesterList.concat(concatList);
          this.getRelearn();
        })
        .catch(err => {});
    },
    semConfirm(e, val) {
      this.semPicker = false;
      this.semester = e.text;
      this.semesterId = e.value;
      this.getRelearn();
    },
    async getRelearn() {
      const params = {
        semester: this.semester == "全部" ? "" : this.semesterId
      };
      const res = await Api.cxbmxk_query(params);
      if (res.code == "1") {
        this.cxList = res.data[0].dataList;
        this.sfkbm = res.data[0].sfkbm;
        this.czCtroller = res.data[0].czCtroller;
      } else {
        this.$toast(res.Msg);
      }
    },
    async bm(item) {
      const params = {
        operate: "bm",
        id: item.cj0721id,
        sfbm: item.sfbm,
        xnxq01id: item.shxq,
        kcid: item.kcid,
        jx0404id: item.jx0404id,
        sfnbm: ""
      };
      let _this = this;
      const res = await Api.cxbmxk_bm_save(params);
      this.$toast(res.Msg);
      setTimeout(function() {
        if (res.code == "1") {
          _this.getRelearn();
        }
      }, 300);
    }
  },
  created() {
    this.semList();
  }
};
</script>
<style lang="less">
.cx {
  .content {
    padding: 0 5% 0;
    .select {
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid @attendance-border-color-6;
      padding: 10px 0 7px;
      background-color: #fff;
    }

    .select select {
      border: 0;
      background: 0;
      outline: 0;
    }
    .select .sem-drop {
      width: 80%;
    }

    .select .van-picker-column__item {
      margin: 0 30%;
    }

    .select .sem-drop > div {
      width: 100%;
    }

    .select .van-popup.van-popup--bottom {
      border-radius: 5px 5px 0 0;
    }

    .select .sem-drop p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: right;
    }

    .select .sem-drop,
    .select .sem-drop div {
      display: flex;
      align-items: center;
      color: @attendance-color-2;
      font-size: 14px;
      justify-content: center;
    }

    .select .sem-drop > div i {
      background: url(../../../../../static/img/Triangle.png) no-repeat center;
      width: 10px;
      height: 10px;
      background-size: 10px 8px;
      margin-left: 5px;
    }

    .select
      .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
      font-weight: 600;
      color: @attendance-color-1;
    }

    .select .van-picker__columns::before {
      width: 140px;
      height: 1px;
      background-color: @attendance-background-color-2;
      content: "";
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
    }

    .select .van-picker__columns::after {
      width: 140px;
      height: 1px;
      background-color: @attendance-background-color-2;
      content: "";
      position: absolute;
      bottom: 70px;
      left: 50%;
      transform: translateX(-50%);
    }

    .list-item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 5%;
      position: relative;
      .item-top {
        padding: 3% 0 3% 6%;

        p {
          height: 42px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          margin-bottom: 2%;
          font-weight: bolder;
          line-height: 42px;
        }
        ul li {
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
      }
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      border-top: 1px solid #dee1e9;
      display: block;
      text-align: center;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      font-weight: bold;
    }
    .bmClass {
      color: #212f6e;
    }
    .qxbmClass {
      color: #f86969;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/cxApply/index_12959.vue